import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { TaglineMarquee } from "@/components/Extras";
import { SERVICES } from "@/lib/api";

const POINTS = [
  "Direct purchase of non-prime, off-grade and wide-spec resin — principal buyer, not a broker",
  "Post-industrial recyclable plastic recovery on scheduled, audit-ready programs",
  "North American pickup coordination — FTL, FCL, mixed and combination loads",
  "Long-term recurring-contract structure with monthly volume commitments",
  "Verified downstream placement into international secondary-material processors",
  "Weigh tickets, BOLs and compliance paperwork ready for finance and sustainability teams",
];

const Services = () => (
  <div data-testid="services-page">
    <PageHero eyebrow="/ OUR BUYER PROGRAM" title={["Recovery", "& purchase."]}
      subtitle="Direct buyer of non-prime resin and post-industrial recyclable plastic. Recovery programs for manufacturers, converters, molders and brand owners across North America." />

    {SERVICES.map((s, i) => (
      <section key={s.n} className={`border-b border-navy/10 ${i % 2 ? "bg-offwhite" : "bg-white"}`}>
        <div className={`max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 grid md:grid-cols-2 gap-12 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}>
          <FadeUp className="md:[direction:ltr]">
            <div className="overflow-hidden">
              <img src={s.img} alt={s.title} onError={(e) => { e.currentTarget.src = "/images/scrap-bales.png"; }}
                className="w-full aspect-[4/3] object-cover" data-testid={`service-img-${s.n}`} />
            </div>
          </FadeUp>
          <div className="md:[direction:ltr]">
            <span className="font-mono text-sm text-emerald">{s.n} / 04</span>
            <FadeUp delay={0.1}>
              <h2 className="font-display font-black text-4xl md:text-5xl tracking-tighter text-navy mt-4 mb-6">{s.title}</h2>
              <p className="text-navy/70 text-lg leading-relaxed">{s.desc}</p>
            </FadeUp>
          </div>
        </div>
      </section>
    ))}

    <TaglineMarquee dark />

    <section className="bg-white py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="font-mono text-xs tracking-[0.3em] text-emerald mb-4">/ THE PACKAGE</div>
          <h2 className="font-display font-black text-4xl md:text-5xl tracking-tighter text-navy">The SAYE buyer advantage.</h2>
        </div>
        <Stagger className="md:col-span-7 md:col-start-6 space-y-0 border-t border-navy/10">
          {POINTS.map((p) => (
            <StaggerItem key={p}>
              <div className="flex items-start gap-4 py-6 border-b border-navy/10" data-testid={`advantage-${p.slice(0,10)}`}>
                <CheckCircle2 className="text-emerald shrink-0 mt-0.5" size={22} />
                <span className="text-navy text-lg">{p}</span>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>

    <section className="bg-navy py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        <h3 className="font-display font-black text-white text-3xl md:text-4xl tracking-tighter">Ready to structure a recurring program?</h3>
        <Link to="/submit-offer" data-testid="services-cta"
          className="group bg-emerald text-navy font-mono text-xs uppercase tracking-widest px-7 py-4 flex items-center gap-2 hover:gap-4 transition-all">
          Sell Your Material <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  </div>
);

export default Services;

